export default __webpack_public_path__ + "img/6820ba71a377409e12361bc79c18779f.png";